import { render, staticRenderFns } from "./OrderLogs.vue?vue&type=template&id=6e61ba5e&scoped=true"
import script from "./OrderLogs.vue?vue&type=script&lang=js"
export * from "./OrderLogs.vue?vue&type=script&lang=js"
import style0 from "./OrderLogs.vue?vue&type=style&index=0&id=6e61ba5e&prod&lang=scss&scoped=true"
import style1 from "./OrderLogs.vue?vue&type=style&index=1&id=6e61ba5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e61ba5e",
  null
  
)

export default component.exports